// extracted by mini-css-extract-plugin
module.exports = {"blocked":"blocked--3Kh6Q","unblocked":"unblocked--38E66"};